import React from "react";

const UploadProgressLoading = ({ uploadProgress }) => {
  return (
    <div className="space-y-4">
      {uploadProgress.map(({ fileName, progress }, index) => (
        <div key={index} className="w-full">
          <div className="md:text-sm xs:text-xs font-medium text-gray-700 mb-1">
            {fileName} ({progress}%)
          </div>
          <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
            <div
              className="bg-green-500 h-full transition-all duration-300 ease-in-out"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default UploadProgressLoading;
